import { type HTMLAttributes, type ReactNode } from 'react';

export type BottomSheetState = 'peek' | 'half' | 'full';

type BottomSheetProps = HTMLAttributes<HTMLDivElement> & { children: ReactNode; state: BottomSheetState };

export function BottomSheet({ children, className = '', state, ...props }: BottomSheetProps) {
  return <div {...props} className={`dd-bottom-sheet ${className}`.trim()} data-sheet-state={state}>{children}</div>;
}
